'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.pageLoadPromise = exports.isPageLoaded = undefined;

var _isBrowser = require('./is-browser');

var _isBrowser2 = _interopRequireDefault(_isBrowser);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var isPageLoaded = exports.isPageLoaded = false; /* global window, document */
var pageLoadPromise = exports.pageLoadPromise = _isBrowser2.default ? new Promise(function (resolve, reject) {
  window.onload = function () {
    exports.isPageLoaded = isPageLoaded = true;
    resolve(document);
  };
}) : Promise.resolve({});
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy91dGlscy9icm93c2VyLXV0aWxzLmpzIl0sIm5hbWVzIjpbImlzUGFnZUxvYWRlZCIsInBhZ2VMb2FkUHJvbWlzZSIsIlByb21pc2UiLCJyZXNvbHZlIiwicmVqZWN0Iiwid2luZG93Iiwib25sb2FkIiwiZG9jdW1lbnQiXSwibWFwcGluZ3MiOiI7Ozs7Ozs7QUFDQTs7Ozs7O0FBRU8sSUFBSUEsc0NBQWUsS0FBbkIsQyxDQUhQO0FBS08sSUFBTUMsNENBQWtCLHNCQUM3QixJQUFJQyxPQUFKLENBQVksVUFBQ0MsT0FBRCxFQUFVQyxNQUFWLEVBQXFCO0FBQy9CQyxTQUFPQyxNQUFQLEdBQWdCLFlBQU07QUFDcEIsWUFMS04sWUFLTCxrQkFBZSxJQUFmO0FBQ0FHLFlBQVFJLFFBQVI7QUFDRCxHQUhEO0FBSUQsQ0FMRCxDQUQ2QixHQU83QkwsUUFBUUMsT0FBUixDQUFnQixFQUFoQixDQVBLIiwiZmlsZSI6ImJyb3dzZXItdXRpbHMuanMiLCJzb3VyY2VzQ29udGVudCI6WyIvKiBnbG9iYWwgd2luZG93LCBkb2N1bWVudCAqL1xuaW1wb3J0IGlzQnJvd3NlciBmcm9tICcuL2lzLWJyb3dzZXInO1xuXG5leHBvcnQgbGV0IGlzUGFnZUxvYWRlZCA9IGZhbHNlO1xuXG5leHBvcnQgY29uc3QgcGFnZUxvYWRQcm9taXNlID0gaXNCcm93c2VyID9cbiAgbmV3IFByb21pc2UoKHJlc29sdmUsIHJlamVjdCkgPT4ge1xuICAgIHdpbmRvdy5vbmxvYWQgPSAoKSA9PiB7XG4gICAgICBpc1BhZ2VMb2FkZWQgPSB0cnVlO1xuICAgICAgcmVzb2x2ZShkb2N1bWVudCk7XG4gICAgfTtcbiAgfSkgOlxuICBQcm9taXNlLnJlc29sdmUoe30pO1xuXG4iXX0=


//////////////////
// WEBPACK FOOTER
// ./~/luma.gl/dist/utils/browser-utils.js
// module id = 1063
// module chunks = 0